import MyIcon from 'components/Icon';
import Spin from 'components/Spin';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadInvoiceHistory } from 'store/Orbita/Invoice/actions';

import HistoryIcon from '../HistoryIcon';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  invoice: any;
  history: any;
  classes: any;
}

interface IStates {}

class History extends Component<IProps, IStates> {
  componentDidMount() {
    if (this.props.invoice) {
      this.props.dispatch(loadInvoiceHistory(this.props.invoice.id));
    }
  }

  render() {
    const { history, classes } = this.props;

    if (history.isFetching) {
      return (
        <div className='loading' style={{ height: '100%' }}>
          <Spin />
        </div>
      );
    } else {
      return (
        <div className={classes.history}>
          <div className='history__title'>
            <div className='col-left'>
              <MyIcon name='icon-invoice-history' />
            </div>
            <div className='col-right'>Histórico da Fatura</div>
          </div>

          <div className='history__content'>
            {history && history.length ? (
              history.map((hst: any, index: any) => (
                <div className={`history__item ${hst.color ? '--' + hst.color : ''}`} key={'history-' + index}>
                  <div className='col-left'>
                    <div className='history__date'>
                      {moment(hst.created_at).format('L')}
                      <span>{moment(hst.created_at).format('HH:mm')}</span>
                    </div>

                    <div className='history__icon'>
                      <HistoryIcon icon={hst.id} />
                    </div>
                  </div>

                  <div className='col-right'>
                    <div className='history__event'>
                      {hst.name}
                      {hst.details && (
                        <small style={{ display: 'block', color: '#666', fontWeight: 400 }}>{!!hst.details.mensagem && hst.details.mensagem}</small>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={'history__item --not-found'} key={'history-default-0'}>
                <div className='col-left'>
                  <div className='history__date'></div>
                </div>

                <div className='col-right'>
                  <div className='history__event'></div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state: any) {
  return {
    history: state.orbita.Invoice.history,
  };
}
export default connect(mapStateToProps)(History);
